<script>
	import { onMount, createEventDispatcher } from "svelte";
	import { Children } from "../../store.js";
	import { SupportUser, Response, isFormAlreadySubmitted } from "./store.js";
	import wrappedFetch from "../../wrappedFetch.js";
	import {User} from "../../store.js";
	import Field from "../../components/FormField.svelte";
	import Select from "../../components/HTMLElements/Select.svelte";
	import TextBox from "../../components/HTMLElements/Textbox.svelte";
	import Spinner from "../../components/HTMLElements/Spinner.svelte";
	import DOB from "../../components/HTMLElements/DOB.svelte";
	import Modal from "../../components/HTMLElements/ModalMessage.svelte";
  import Steps from "./steps.svelte";
  import * as objectWrapper from "../../components/Utils/ObjectWrapper.js";
  import * as validate from "../../components/Utils/ValidateFormFIelds.js";
	let children = [];
	let selectedChild = "";
	let errMsg = "";
	let reasonText = "";
	 let improvementText =$Response.futureImprovement? $Response.futureImprovement: "";
	 let commentsText =$Response.furtherComments? $Response.furtherComments : "";
	let isPageLoading = true;
	let showChildNameTextBox = false;
	let reference = "";
	let showModal = false;
	let isDirty = false;
  let childObject ={forename:"",surname:"",dob:""}
  let dobStr;
  let wrappedObj ;

	const getChildren = async () => {
		let resp = await wrappedFetch("/child/getchildren", { method: "post" });
		return (await resp.json()).children;
	};
	const dispatch = new createEventDispatcher();
	const textAreaValue = (e) => {
		if (e.target.id=="improvement")
		{
		improvementText = e.target.value;
		$Response.futureImprovement = improvementText;
		}
		if(e.target.id == "comments")
		{
		commentsText = e.target.value;
		$Response.furtherComments = commentsText;
		}
		//  preference.reason = reasonText;
	};
	const addFormSubmittedCookie = () => {
		let expires = new Date(Date.now() + 120 * 1000).toUTCString();
		document.cookie = `cookieName=formJustSubmitted; expires=${expires};path=/;`;
	};
	const handleSubmit = async () => {
	isDirty = true;

    // if(showChildNameTextBox)
    // {
    //   if (!validate.validate(wrappedObj)) {
    //     errMsg = "Please check required fields have valid data.";
    //     wrappedObj = wrappedObj;      
    //     return;
    // }
    // else selectedChild = wrappedObj.forename.value+" "+wrappedObj.surname.value+" ("+dobStr+")";
    // }
	// 	if (selectedChild == "" || reasonText == "") {
	// 		errMsg = "Please ensure that you have completed the required fields.";
	// 		return;
	// 	}
	// 	$Response.childname = selectedChild;
    // $Response.reason = reasonText;
    // if(showChildNameTextBox)
    // $Response.childObject = wrappedObj;
	// 	$Response.step4 = true;
    // $Response.username = $SupportUser == null ? "" : $SupportUser.username;
		const response = await wrappedFetch(`/furtherfeedback/SaveFurtherFeedbackFormData`, {
			method: "post",
			body: JSON.stringify($Response),
			headers: {
				"Content-Type": "application/json",
			},
		});
		reference = await response.text();
	// 	if (reference) addFormSubmittedCookie();
	

		showModal = true;
	};

	const viewForm = () => {
		showModal = false;
		dispatch("pageChange", "/support/summary");
	};
	const handleModalClose = () => {
		showModal = false;
		if (User != null) dispatch("pageChange", "/user/home");
		else dispatch("pageChange", "/");
	};

	onMount(async () => {
		if (!$Response.step2 || isFormAlreadySubmitted()) dispatch("pageChange", "/furtherfeedback/step2");
		$Response.username = $User.username;
		$Response.laId= $User.laID;
		 improvementText =$Response.futureImprovement? $Response.futureImprovement: "";
		 commentsText =$Response.furtherComments? $Response.furtherComments : "";	
	
		isPageLoading = false;

	});
</script>

{#if showModal}
	<Modal
		bind:showModal
		buttonText="Exit"
		on:continue={() => handleModalClose()}>
		<h1 class="title is-3">Thank you</h1>
		<p>Thank you for completing the form.Your feedback is important to us.</p>	
		<!-- <button class="button is-small" on:click={viewForm}>
			View Submitted Form
		</button> -->
	</Modal>
{/if}

{#if !isPageLoading}
<Steps
	backUrl="/furtherfeedback/step2"
	buttonText="Submit"	
	bind:isPageLoading
	on:handleNext={() => handleSubmit()}
	on:pageChange={(event) => dispatch('pageChange', event.detail)}>
	<div class="column">
	
			<div class="columns is-desktop">
				<div class="column">				
		<Field label="5. What would you like us to improve in the future?" isRequired ={false}>
			<span slot="inputField">
				<textarea
				id="improvement"
					maxlength="1000"
					{improvementText}
					on:input={textAreaValue}
					rows="7"
					style="width:100%;margin-top:10px;padding:5px;" >{improvementText}</textarea>
				<p style="font-size:0.8rem;">
					({improvementText.length}
					of 1000 characters used)
				</p>
			</span>
		</Field>

		<Field label="6. Do you have any further comments?" isRequired ={false}>
			<span slot="inputField">
				<textarea
				id="comments"
					maxlength="1000"
					{commentsText}
					on:input={textAreaValue}
					rows="7"
					style="width:100%;margin-top:10px;padding:5px;" >{commentsText}</textarea>
				<p style="font-size:0.8rem;">
					({commentsText.length}
					of 1000 characters used)
				</p>
			</span>
		</Field>
		<div>
			{#if errMsg != ''}
				<div class="notification is-invalid">
          <p class="help" style="margin-bottom:0px">{@html errMsg}</p>
        </div>
			{/if}
		</div>
	</div>
</Steps>
{/if}
